module.exports = __webpack_public_path__ + "media/components/assets/subtitle_img-2e3bbea11133ab6de8c2a7bc9214bdc3.svg";